var _style, _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 321 213",
    style: {
      enableBackground: "new 0 0 321 213"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3E87BB;}\n\t.st1{fill:#307FB7;}\n\t.st2{fill:#2276B2;}\n\t.st3{fill:#0D5BA2;}\n\t.st4{opacity:0.5;fill:#00549E;}\n\t.st5{fill:#00308A;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 321,
    height: 213
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.8,72.4c30.9,8.9,64.7,15.3,96.3,21.7c30.8,6.3,62.4,15.9,84.9,35.4V0H25.3C49.5,29.6,85.7,56.9,139.8,72.4 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.4,27.9c24.8,9.4,52.1,12.5,78.1,19.4c41.2,10.8,78.9,31.6,107,58.7c14.6,14.1,26.4,29.7,37.6,45.6V0H53.2 C65.7,11.6,81.1,21.3,98.4,27.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.1,40.3C245,65.4,280,76.7,321,74.9V0H170.8C185.8,13.4,200.7,26.9,216.1,40.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.6,11.8c59.8,8.2,123-1.5,173.8,36.2c13.8,10.2,27,21.7,41.6,31.2V0H68.3C79.1,5.6,91.5,9.8,105.6,11.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M321,60V0h-79.7C269.8,45.1,307.2,30,321,60z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBgMobile);
export default __webpack_public_path__ + "static/media/bannerBgMobile.f630294f727e08624a186812b088e965.svg";
export { ForwardRef as ReactComponent };